// ============================================================
// Listing Preview Lead Funnel – Shared Types
// ============================================================

export type ListingPreviewStatus =
  | 'pending'
  | 'extracting'
  | 'generating_clips'
  | 'rendering'
  | 'completed'
  | 'failed'
  | 'cached';

export interface ListingData {
  title: string | null;
  address: string | null;
  imageUrls: string[];
}

export interface ListingPreviewJob {
  id: string;
  user_id: string | null;
  session_id: string;
  source_url: string;
  source_url_hash: string;
  source_domain: string | null;
  listing_title: string | null;
  listing_address: string | null;
  images_found: string[];
  images_used: string[];
  images_found_count: number;
  images_used_count: number;
  status: ListingPreviewStatus;
  fal_request_ids: string[];
  clip_urls: string[];
  shotstack_render_id: string | null;
  preview_video_url: string | null;
  preview_video_path: string | null;
  share_slug: string | null;
  aspect_ratio: string;
  error_message: string | null;
  failure_reason: string | null;
  is_cached: boolean;
  generation_time_ms: number | null;
  signed_up_after_preview: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreatePreviewRequest {
  url: string;
  sessionId: string;
}

export interface CreatePreviewResponse {
  jobId: string;
  shareSlug: string;
  status: ListingPreviewStatus;
  listing: ListingData;
  images: string[];
  cached: boolean;
  videoUrl?: string;
  error?: string;
}

export interface PollPreviewResponse {
  status: ListingPreviewStatus;
  progress: number;
  videoUrl?: string;
  listing: ListingData | null;
  images: string[];
  shareSlug: string | null;
  error?: string;
  failureReason?: string;
}

export interface PreviewPageData {
  jobId: string;
  videoUrl: string;
  listing: ListingData;
  images: string[];
  shareSlug: string;
  createdAt: string;
}

export type ListingPreviewEventType =
  | 'landing_page_view'
  | 'listing_url_submitted'
  | 'extraction_success'
  | 'extraction_failure'
  | 'preview_generation_started'
  | 'preview_generation_completed'
  | 'share_link_copied'
  | 'signup_clicked'
  | 'signup_completed'
  | 'preview_download_attempted'
  | 'preview_downloaded'
  | 'full_version_clicked'
  | 'rate_limit_triggered';

export enum FunnelStep {
  VALIDATING = 0,
  EXTRACTING = 1,
  SELECTING = 2,
  GENERATING = 3,
  RENDERING = 4,
}

export interface FunnelStepConfig {
  step: FunnelStep;
  label: string;
  description: string;
}

export interface ListingProviderDisplay {
  id: string;
  name: string;
  hostname: string;
}

export interface RateLimitResult {
  allowed: boolean;
  reason?: string;
  message?: string;
}
